export default __webpack_public_path__ + "static/media/illustration-algocare-w@2x.364dc4c3.webp";